import script from "./DetailTableListInvoiceProxyNonPO.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailTableListInvoiceProxyNonPO.vue?vue&type=script&setup=true&lang=js"

import "./DetailTableListInvoiceProxyNonPO.vue?vue&type=style&index=0&id=49e3f1b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e3f1b4"]])

export default __exports__